export default "__VITE_ASSET__e239deef__"